import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_GEOGRAPHIC_REGIONS_QUERY = queryWithFallbackKey(
    gql`
        query getGeographicRegionListing($defaultLanguage: String!) {
            getObjectFolder(fullpath: "/Geographic/Regions", defaultLanguage: $defaultLanguage) {
                children {
                    ... on object_GeographicRegion {
                        id
                        key
                        name
                        countries {
                            id
                            key
                            name
                            hubspotYageoContactUs_enabled: hubspotYageoContactUs_country_enabled
                            hubspotYageoContactUs_fieldValue: hubspotYageoContactUs_country_fieldValue
                            hubspotYageoContactUs_subregionFieldName: hubspotYageoContactUs_country_subregionFieldName
                            subnationalRegionType {
                                ... on object_SubnationalRegionType {
                                    id
                                    key
                                    name
                                    selectionPrompt
                                }
                            }
                            subnationalRegions {
                                id
                                key
                                name
                                hubspotYageoContactUs_enabled: hubspotYageoContactUs_subregion_enabled
                                hubspotYageoContactUs_fieldValue: hubspotYageoContactUs_subregion_fieldValue
                            }
                        }
                    }
                }
            }
        }
    `,
    'GET_GEOGRAPHIC_REGIONS_QUERY'
);

export function getGeographicRegionsQueryVariables(localeCode: LocaleCode) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
    };
}
